/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aml_Lot_Virtual_StockInputs */

const vi_aml_lot_virtual_stock = /** @type {(inputs: Aml_Lot_Virtual_StockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tồn kho`)
};

/**

* @param {Aml_Lot_Virtual_StockInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const aml_lot_virtual_stock = /** @type {((inputs?: Aml_Lot_Virtual_StockInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aml_Lot_Virtual_StockInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_aml_lot_virtual_stock(inputs)
});